<template>
    <div>
        <div class="card dashcard mb-3">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="$refs.apuracao.selecionar_apuracao()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            placeholder="Selecione Profissional..."
                            icon2="fas fa-user-md fa-fw" 
                            type="select" 
                            optionsMode="aql"
                            service="medicos.index"
                            optionsName="medicos-cadastro"
                            :optionsParm="{ ativos: true }"
                            optionsData="id_pessoa"
                            :edicao="na_recepcao"
                            v-model="medico" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            placeholder="Baseado na Regra de Rateio"
                            icon="far fa-calendar-alt fa-fw" 
                            type="select" 
                            :optionsList="[
                                { id: 'P', search: 'Baseado na Produção' },
                            ]"
                            optionsData="id"
                            v-model="origem" />
                    </div>
                    <div class="col col-12 col-md-4 d-flex flex-column">
                        
                    </div>
                </div>
            </div>
        </div>

        <repasse-apuracao 
            v-if="!iniciando"
            ref="apuracao"
            :id_medico="medico" 
            :origem="origem" 
            :simulacao="true" 
            :direto_medico="true"
            :na_recepcao="na_recepcao"
            :exibir_saldo="exibir_saldo"
            :parms="{
                no_devol: no_devol, 
                periodo: filtro,
            }" />

    </div>
</template>

<script>
import $ from 'jquery';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import RepasseApuracao from '../repasse/RepasseApuracao.vue';

export default {
    data() { 
        return { 
            medico: "", 
            origem: "P",
            filtro: { 
                inicio: "",
                fim: "",
                periodo: "h",
                semana: "",
                mes: "", 
            }, 
            exibir_saldo: false, 
            iniciando: true,
            no_devol: true, 
        }
    },

    props: [], 

    components: { 
        AzPeriodo, 
        AzInput, 
        RepasseApuracao
    },

    computed: { 
        na_recepcao: function () { 
            return this.$route.path.substr(0,9) == '/recepcao';
        }
    },

    mounted() { 

        if ( this.na_recepcao ) { 

            this.$store.commit('setBreadcrumb', 
                [
                    { name: "Recepção", path: "/recepcao"},
                    { name: "Relatório da Produção", path: "/recepcao/apuracao"},
                ]);

            this.$util.load(this, { 
                service: 'configuracoes',
                func: 'index',
                parms: { 
                    where: {
                        st_slug: 'repasse-recepcao-exibir-devolucao',
                        fl_ativo: '1',
                    }
                },
                loadTo: res => { 
                    if ( res.length ) { 
                        this.no_devol = false;
                    }
                },
                final: () => { 
                    console.log('no_devol', this.no_devol);
                    this.iniciando = false;
                }
            });

        } else { 

            this.$store.commit('setBreadcrumb', 
                [
                    { name: "Consultório", path: "/consultorio"},
                    { name: "Apuração da Produção", path: "/consultorio/apuracao"},
                ]);

            this.medico = this.$store.state.user.id_pessoa;

            this.$util.load(this, { 
                service: 'configuracoes',
                func: 'index',
                parms: { 
                    where: {
                        st_slug: 'repasse-consultorio-exibir-saldo',
                        fl_ativo: '1',
                    }
                },
                configs: [
                    'repasse-consultorio-exibir-devolucao'
                ],
                loadTo: res => { 
                    if ( res.length ) { 
                        this.exibir_saldo = true;
                    }

                    if ( this.$store.state.contexto['repasse-consultorio-exibir-devolucao'] > 0 ) { 
                        this.no_devol = false; 
                    }
                },
                final: () => { 
                    this.iniciando = false;

                    this.$nextTick(() => { 
                        this.$refs.apuracao.selecionar_apuracao();
                    });
                }
            });

        }   

        this.$nextTick(() => { 
            $('.tooltip').tooltip('hide');
        });
    }
}
</script>